module.exports = __webpack_public_path__ + "img/warrior.e522299c.png";